<div *transloco="let t" class="group relative">
  <ng-content />
  @if (isActive()) {
    <button
      class="absolute! right-0 top-0 z-30 transition-opacity md:opacity-0 md:group-hover:opacity-100"
      data-testid="badge"
      size="xs"
      tuiButtonX
      type="button"
      (click)="remove.emit()">
      {{ t('Supprimer') }}
    </button>
  }
</div>
